import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type SessionClinicalCodesResponse } from '../../contracts/types';
import { unconfirmClinicalCode } from '../api/session-codes-api';
// import { useAtomValue } from 'jotai';
// import {
//   GET_DEMO_DOCUMENT_BY_ID,
//   GET_DOCUMENT_BY_ID,
// } from '../query/useQueryDocumentById';
// import { GET_SESSION_BY_ID } from '../query/useQuerySessionById';
import { CodedClinicalEntityStatus } from '@heidi/schema/ml-scribe';
import { SESSION_CLINICAL_CODES_MUTATION_SCOPE } from '../../contracts/keys';
import { GET_SESSION_CLINICAL_CODES } from '../query/session-clinical-codes-cache';

// type Props = {
//   sessionId: string;
// };

// type mutationFnProps = {
//   currentDocuments: DocumentResponse[];
// };

export const UNCONFIRM_EMBEDDING_STATUS = 'UNCONFIRM_EMBEDDING_STATUS';

export function useMutateUnconfirmEmbeddingStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UNCONFIRM_EMBEDDING_STATUS],
    scope: { id: SESSION_CLINICAL_CODES_MUTATION_SCOPE },
    mutationFn: async (input: { sessionId: string; entityIds: string[] }) => {
      return await unconfirmClinicalCode({
        sessionId: input.sessionId,
        entity_ids: input.entityIds,
      });
    },
    // onSuccess: async (_, input) => {
    //     await invalidateSesionClinicalCodes(input.sessionId);
    //   },
    onMutate: (variables) => {
      const { sessionId, entityIds } = variables;
      queryClient.setQueryData<SessionClinicalCodesResponse>(
        [GET_SESSION_CLINICAL_CODES, { sessionId: sessionId }],
        (oldData) => {
          if (!oldData) {
            return undefined;
          }
          const nextEntities = (oldData.clinical_entities ?? []).map((entity) => {
            const shouldUnconfirm = entity.entity_id
              ? entityIds.includes(entity.entity_id)
              : false;
            return shouldUnconfirm
              ? { ...entity, status: CodedClinicalEntityStatus.PENDING }
              : entity;
          });
          return {
            ...oldData,
            clinical_entities: nextEntities,
            updated_at: new Date().toISOString(),
          };
        }
      );
    },
  });
}
